export const server = "https://chireva-api.onrender.com/api/v2";

export const backend_url = "https://chireva-api.onrender.com/";
